import { useQuery } from "@tanstack/react-query";

import { SATOSPortalNew } from "@/DataAdapter/Portal";
import { SATOSPortal } from "@/DataAdapter/SATOSPortal";

import { OmniaDataPoints } from "@/model/SATOSLive/Omnia/OmniaDataPointResponse";
import { TimeSeriesResponse } from "@/model/SATOSLive/Omnia/TimeSeriesResponse";
import { LiveSettingsResponse } from "@/model/SATOSLive/Settings/SettingsResponse";

import { ApplicationQueryKeys } from "@/service/ApplicationQueries";

export const useFetchAllOmniaTimeseries = () => {
	return useQuery<TimeSeriesResponse, any>({
		queryKey: [LiveQueryKeys.omnia, LiveQueryKeys.timeseries],
		queryFn: async () => {
			const response = await fetch("/api/omnia");

			if (!response.ok) {
				throw new Error(
					"Server error - Remember to set ClientId and ClientSecret in Azure portal",
				);
			}

			return await response.json();
		},
	});
};

export const useSearchOmniaByName = (search: string) => {
	return useQuery<TimeSeriesResponse, any>({
		queryKey: [LiveQueryKeys.omnia, search],
		queryFn: () => SATOSPortal.SearchOmniaByName(search),
		enabled: !!search,
	});
};

export const useFetchMultipleTagsCurrentValues = (request: string[]) => {
	return useQuery<OmniaDataPoints[], any>({
		queryKey: [
			LiveQueryKeys.omnia,
			LiveQueryKeys.datapoints,
			LiveQueryKeys.multiple,
			request,
		],
		queryFn: () => SATOSPortal.GetMultipleTagsCurrentValues(request),
		enabled: request.length > 0,
		refetchInterval: 3000,
	});
};

export const useFetchLiveSettings = () => {
	return useQuery<LiveSettingsResponse, any>({
		queryKey: [
			LiveQueryKeys.live,
			LiveQueryKeys.settings,
			ApplicationQueryKeys.user,
		],
		queryFn: () => SATOSPortalNew.fetchLiveSettings(),
	});
};

export class LiveQueryKeys {
	static readonly live = "live";
	static readonly omnia = "omnia";
	static readonly timeseries = "Timeseries";
	static readonly settings = "settings";
	static readonly saveTagValue = "saveTagValue";
	static readonly datapoints = "datapoints";
	static readonly multiple = "multiple";
}
